import type { FieldControl, FieldDataType, FieldType, FieldWidth, IFieldDefinition } from '@platform/core/types';

const MAP: Record<FieldType, { control: FieldControl; dataType: FieldDataType; width: FieldWidth }> = {
  text: { control: 'input', dataType: 'text', width: 'M' },
  textarea: { control: 'textarea', dataType: 'text', width: 'L' },
  number: { control: 'number', dataType: 'number', width: 'S' },
  select: { control: 'picker', dataType: 'text', width: 'S' },
  date: { control: 'date', dataType: 'date', width: 'S' },
  user: { control: 'user', dataType: 'ref', width: 'M' },
  tags: { control: 'tags', dataType: 'text', width: 'L' },
  area: { control: 'tree', dataType: 'ref', width: 'M' },
  iteration: { control: 'tree', dataType: 'ref', width: 'M' },
  ref: { control: 'lookup', dataType: 'ref', width: 'M' },
  lookup: { control: 'lookup', dataType: 'ref', width: 'M' },
  file: { control: 'file', dataType: 'ref', width: 'M' },
  boolean: { control: 'switch', dataType: 'boolean', width: 'S' },
  json: { control: 'json', dataType: 'json', width: 'L' },
};

const SHORT_TEXT = /(^|_)(code|no|num|number|regno|ref|id|phone|zip|postcode|year|qty)$/i;

export const controlOf = (f: IFieldDefinition): FieldControl => MAP[f.type]?.control ?? 'input';
export const dataTypeOf = (f: IFieldDefinition): FieldDataType => MAP[f.type]?.dataType ?? 'text';

/** Ширина поля (FORM_LAYOUT §3): явна → короткий текст → довгі опції → тип. */
export function widthOf(f: IFieldDefinition): FieldWidth {
  if (f.width) return f.width;
  if (f.type === 'text' && SHORT_TEXT.test(f.key)) return 'S';
  if (f.type === 'select' && (f.options ?? []).some((o) => o.value.length > 16)) return 'M';
  return MAP[f.type]?.width ?? 'M';
}

export const isPerson = (f: IFieldDefinition): boolean => f.type === 'user';
export const isDateRole = (key: string): boolean => key === 'start' || key === 'finish' || key === 'due';

/** Ширина колонки таблиці за типом (UIUX tables/columns). */
export function columnWidth(f: IFieldDefinition): string {
  switch (f.type) {
    case 'number': return '100px';
    case 'date': return '104px';
    case 'select': return '140px';
    case 'user': return '160px';
    default: return 'minmax(150px, 1fr)';
  }
}
